import type { FaireThemeEntity } from "../../entity_types/theme";

export const rustic_depot_cabin_socks_cozy_comfort: FaireThemeEntity = {
  token: "rustic-depot-cabin-socks-cozy-comfort",
  type: "theme",
  retailerToken: "r_464eox2tas",
  name: "Cabin Socks & Cozy Comfort",
  description: "Cozy knit socks your customers grab every fall",
  bgColor: "#F0E0D0",
  tileBgColor: "#9e2d4d",
  productTokens: [
    "p_cufdf4884q",
    "p_s4bzxpbknj",
    "p_nt4kbedrwa",
    "p_7s2p2guseh",
  ],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
